"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSimulationStore = void 0;
const pinia_1 = require("pinia");
const useStateSlice_1 = require("./useStateSlice");
exports.useSimulationStore = (0, pinia_1.defineStore)("simulation", {
    state() {
        return {
            uuid: crypto.randomUUID(),
            step: 1,
            abc: null,
            banorte: null,
            banorteInsurer: null,
            activeComponent: "steps",
            activeCard: null,
            bbva: {},
            distributor: null,
            distributors: {},
            enganche: 0,
            enganchePercentage: 0,
            hasInsurance: false,
            insurer: null,
            insurers: [],
            plazo: 24,
            powerTrain: null,
            exteriorColor: null,
            interiorColor: null,
            iframe: false,
            state: (0, useStateSlice_1.useStateSlice)()
        };
    },
    actions: {
        async setStep(index) {
            this.step = index;
        },
        reset() {
            this.enganche = 30;
            this.distributor = null;
            this.bbva = {};
            this.abc = {};
            this.insurer = null;
            this.insurers = [];
            this.plazo = 24;
            this.hasInsurance = false;
        }
    }
});
